<template>
  <div>
    <gmap-map
      :center="center"
      :zoom="11"
      style="width:100%;  height: 400px;"
    >
      <gmap-marker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        @click="center=m.position"
      ></gmap-marker>
    </gmap-map>
  </div>
</template>

<script>
export default {
  name: "GoogleMap",
  data() {
    return {
      // default to Montreal to keep it simple
      // change this to whatever makes sense
      center: { lat: 48.801656, lng: 17.410158 },
      markers: [],
      places: []
    };
  },
  mounted() {
        const marker = { lat: 48.801656, lng: 17.410158 };
        this.markers.push({ position: marker });
        this.places.push(this.currentPlace);
        this.center = marker;
  }
};
</script>


// WEBPACK FOOTER //
// src/components/GoogleMap.vue